const environment = {
  production: true,
  apiBase: 'https://sub-merchant-back-office-backend.twallet-ph-uat.opn.dev',
  aesKey: 'passwordencryptaeskeysubmerchant',
};

export default environment;
